import React, { useState } from 'react'
import CallLogs from './CallLogs';
import Call from './CallOption/Main'
export default function Main() {
    const commonWidth = "50%";
    const [tab, setTab] = useState("call")
   

    const handleTab = (type) => {
        setTab(type)
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        <div className='btn-grp-own-lead-manage-new' role="group" aria-label="onboard-btn" >
                            <button className={tab == "call" ? "btn-active" : "btn"} style={{ width: commonWidth }} onClick={() => handleTab("call")}>
                                Call
                            </button>
                            <button className={tab == "callLogs" ? "btn-active" : "btn"} style={{ width: commonWidth }} onClick={() => handleTab("callLogs")}>
                                Call Logs
                            </button>

                        </div>
                    </div>
                </div>
            </div>


                    {
                        tab == "callLogs" ? 
                        <CallLogs /> 
                        :''
                    }
                    {
                        tab == "call" ? 
                        <Call /> 
                        :''
                    }
        </>
    )
}
